export default "__VITE_ASSET__DXHt1l7$__";